module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_8023.a012bfa9.png";